// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3U56b","fullView":"styles_fullView__Y9DD8"};